export enum LootboxRoutes {
  projects = 'projects',
  box = 'app',
  jackpot = 'jackpot',
  gems = 'gems',
  vault = 'vault',
  history = 'history',
}
